import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {GenericPageResponse, GenericResponse} from '@app/core/backend';
import {API_ENDPOINTS} from '@app/constants';
import {Notice} from "@app/modules/configuration/model/notice.model";

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private readonly http: HttpClient) {
  }

  getDashboardData() {
    return this.http.post<GenericResponse<any>>(
      API_ENDPOINTS.DASHBOARD_DATA_URL,
      {}
    );
  }

  loadDashboardNoticeData(currentPage: number, pageSize: number, event: any) {

    let params: HttpParams;
    if (event?.sortField) {
      params = new HttpParams()
        .set('page', currentPage)
        .set('size', pageSize)
        .set('sort_by', event.sortField)
        .set('sort_direction', event.sortOrder === 1 ? 'ASC' : 'DESC');
    } else {
      params = new HttpParams()
        .set('page', currentPage)
        .set('size', pageSize);
    }

    return this.http.post<GenericResponse<GenericPageResponse<Notice>>>(
      API_ENDPOINTS.DASHBOARD_NOTICE_DATA_URL, {}, {params}
    );
  }

  markAsRead(id: any) {
    return this.http.get<GenericResponse<any>>(
      API_ENDPOINTS.DASHBOARD_NOTICE_DATA_MARK_AS_READ.replace('{notice_id}', id)
    );
  }
}
